
import { Component, inject, output } from '@angular/core';
import { AppPermissions, AuthenticationService } from '@my-aon/auth';
import { CommonDialogsService, NotifyService } from '@my-aon/shared';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrl: './footer.component.scss',
    standalone: true,
    imports: [
        TranslatePipe
    ],
})
export class FooterComponent {

    readonly auth: AuthenticationService = inject(AuthenticationService);
    readonly notify: NotifyService = inject(NotifyService);
    readonly translate: TranslateService = inject(TranslateService);
    readonly appDialogs: CommonDialogsService = inject(CommonDialogsService);

    year = new Date().getUTCFullYear();

    openContactUsDialog() {
        if (!this.auth.hasAnyPermission(AppPermissions.GENERAL_CONTACT_US_SEND_REQUEST)) {
            this.notify.error(this.translate.instant('ERRORS.FORBIDDEN_DESC'), this.translate.instant('ERRORS.FORBIDDEN'));
            return;
        }
        this.appDialogs.openContactUsDialog().subscribe();
    }
}
